import { Field } from 'redux-form';
import React from 'react';
import './inputField.scss';
const SwitchInput = (props) => {
    const { fieldName, fieldIsDisbale } = props;

    return <>
        <div className="form-field form-field-switch">

            <label className="switch">
                <Field
                    name={fieldName}
                    component={({ input }) => (
                        <input
                            type="checkbox"
                            checked={!!input.value} // Ensure it's boolean
                            onChange={(e) => input.onChange(e.target.checked)}
                            disabled={fieldIsDisbale}
                        />
                    )}
                />
               
                <span className="slider round" />
            </label>
        </div>
    </>
}

export default SwitchInput;